import styled from 'styled-components';
import { getContrastColor } from '../../utils/colorUtils';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  background-color: ${props => props.bgColor};
  border-radius: 10px;
  transition: background-color 0.3s ease;
`;

export const FormBox = styled.div`
  background: ${props => props.bgColor};
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 450px;
  transition: background-color 0.3s ease;
`;

export const Title = styled.h1`
  text-align: center;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  margin-bottom: 30px;
  font-size: 28px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  font-weight: 600;
  font-size: 14px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 2px solid ${props => {
    const c = getContrastColor(props.bgColor || '#ffffff');
    return c === '#ffffff' ? '#444' : '#ddd';
  }};
  border-radius: 5px;
  font-size: 14px;
  transition: border-color 0.3s;
  font-family: inherit;
  
  background-color: ${props => {
    const c = getContrastColor(props.bgColor || '#ffffff');
    return c === '#ffffff' ? '#1a1a1a' : '#f8f9fa';
  }};
  color: ${props => getContrastColor(props.bgColor || '#ffffff') === '#ffffff' ? '#ffffff' : '#333'};

  &::placeholder { color: #999; }

  &:focus {
    outline: none;
    border-color: ${props => props.accentColor || '#667eea'};
    box-shadow: 0 0 0 3px ${props => props.accentColor ? props.accentColor + '20' : 'rgba(102, 126, 234, 0.1)'};
  }

  &:hover { border-color: ${props => props.accentColor || '#667eea'}; }
`;

export const Button = styled.button`
  width: 100%;
  padding: 12px;
  background: var(--accent-color, #667eea);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px var(--accent-color, rgba(102, 126, 234, 0.4));
  }

  &:active { transform: translateY(0); }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const ErrorMessage = styled.p`
  color: #e74c3c;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
`;

export const LinkText = styled.p`
  text-align: center;
  margin-top: 20px;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};

  a {
    color: var(--accent-color, #667eea);
    text-decoration: none;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;

    &:hover { text-decoration: underline; opacity: 0.8; }
  }
`;
